// The inbox is read by the action centre, not by this module: review-sharing keys
// live with the domain rather than with whichever surface consumes them.
export const REVIEW_SHARING_INBOX_QUERY = '/review-sharing/grants/inbox';

// Resolved sharing config for a single community (override, community
// default, or none). See orgSharingConfig.ts.
export const ORG_SHARING_CONFIG_QUERY =
  '/review-sharing/communities/effective-sharing-configuration';

// Every id this endpoint takes is a path segment, so the key is the route shape
// rather than a usable URL: the caller builds the path from the payload it is
// already keyed on.
export const REVIEW_SHARING_COMMUNITY_REVIEWS_QUERY =
  '/review-sharing/communities/:communityID/suppliers/:supplierID/reviews';

// Suppliers in a community holding an active override, any mode. See
// supplierOverrides.ts.
export const SUPPLIER_OVERRIDES_QUERY = '/review-sharing/communities/supplier-overrides';

// Granted grants for suppliers in a community currently resolved to
// access_on_request. See grantedAccess.ts.
export const GRANTED_ACCESS_QUERY = '/review-sharing/communities/granted-access';

export const REVIEW_SHARING_COMMUNITY_SIGNALS_QUERY =
  '/review-sharing/suppliers/:supplierID/community-signals';

// Per-row signal counts behind the assessment table. See assessmentSignals.ts.
export const ASSESSMENT_SIGNAL_INDEX_QUERY =
  '/review-sharing/suppliers/:supplierOrgID/assessment-signals';

// The signals behind one assessment row's counts. See assessmentSignals.ts.
export const CONTROL_SIGNALS_QUERY =
  '/review-sharing/suppliers/:supplierOrgID/assessment-signals/controls/:controlID';

// One owner's full review. Every id is a path segment, so the key is the route
// shape rather than a usable URL, like the reviews list above it.
export const REVIEW_SHARING_REVIEW_DETAIL_QUERY =
  '/review-sharing/communities/:communityID/suppliers/:supplierID/reviews/:ownerOrgID';

// Resolved sharing config for one supplier within a community (supplier
// override, org override, community default, or none). See
// supplierSharingConfig.ts.
export const SUPPLIER_SHARING_CONFIG_QUERY =
  '/review-sharing/communities/suppliers/effective-sharing-configuration';

// Eligible viewer orgs for one supplier within a community, each annotated
// with its per-category grant state. Backs the sharing modal's search/add,
// "organisations with access" and "access requests" sections. See
// supplierGrants.ts.
export const ELIGIBLE_VIEWERS_QUERY = '/review-sharing/communities/suppliers/eligible-viewers';

// Every community the caller's org actively belongs to, each flagged with
// whether review sharing is enabled for it. See reviewSharingCommunities.ts.
export const REVIEW_SHARING_COMMUNITIES_QUERY = '/review-sharing/communities';
